<script setup lang="ts">
import DeliveryPlanType from "@/types/DeliveryPlan"

const props = defineProps<{
  detailData: DeliveryPlanType;
  rowSpan: number;
}>();
</script>

<template>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan">{{ props.detailData.leavingDiffTime }}</td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td rowspan="rowSpan"></td>
  <td></td>
</template>

<style scoped>
#trip-detail-table td {
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 2px;
  padding-right: 2px;
  text-align: center;
  font-weight: bold !important;
  border: 1 !important;
  border-width: 2px !important;
}
</style>
